import React from 'react';
import { motion } from 'framer-motion';

const Installation = () => {
  const bendingMethods = [
    { title: 'Horkovzdušná metoda', description: 'Ohýbání za tepla pro jemné zakřivení a plynulé oblé tvary.', color: 'text-brand-500' },
    { title: 'Frézování (V-Groove)', description: 'Vyfrézování drážek pro přesné 90° ohyby a ostré lomené tvary.', color: 'text-accent-teal' },
    { title: 'Kombinovaný přístup', description: 'Spojení tepla a frézování pro komplexní architektonické prvky.', color: 'text-accent-sage' }
  ];

  return (
    <section id="installation" className="py-32 bg-arch-light dark:bg-[#13151A] border-b border-arch-border dark:border-dark-border relative transition-colors duration-300">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <motion.div className="mb-20" initial={{ y: 50, opacity: 0 }} whileInView={{ y: 0, opacity: 1 }} viewport={{ once: true }}>
          <div className="flex items-center space-x-4 mb-6">
            <div className="w-8 h-[1px] bg-brand-500"></div>
            <span className="text-xs font-bold text-arch-gray dark:text-gray-400 uppercase tracking-widest">Zpracování</span>
          </div>
          <h2 className="text-4xl lg:text-5xl font-bold text-arch-dark dark:text-white tracking-tight">Postupy a instalace.</h2>
        </motion.div>

        <div className="grid lg:grid-cols-2 gap-16">
          
          {/* Methods */}
          <div className="space-y-12">
            <div>
              <h3 className="text-lg font-bold text-arch-dark dark:text-white uppercase tracking-widest mb-6 pb-4 border-b border-arch-border dark:border-dark-border">Metody tvarování</h3>
              <div className="space-y-6">
                {bendingMethods.map((method, index) => (
                  <div key={index} className="flex space-x-6">
                    <div className={`${method.color} font-mono font-bold text-lg`}>0{index + 1}</div>
                    <div>
                      <h4 className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-wider mb-2">{method.title}</h4>
                      <p className="text-arch-gray dark:text-gray-400 text-sm">{method.description}</p>
                    </div>
                  </div>
                ))}
              </div>
            </div>

            <div>
              <h3 className="text-lg font-bold text-arch-dark dark:text-white uppercase tracking-widest mb-6 pb-4 border-b border-arch-border dark:border-dark-border">Systémy spojů</h3>
              <div className="grid grid-cols-2 gap-8">
                <div>
                  <h4 className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-wider mb-3">Bezešvá instalace</h4>
                  <ul className="text-sm text-arch-gray dark:text-gray-400 space-y-2">
                    <li><span className="text-accent-teal mr-2">/</span> Monolitický dojem</li>
                    <li><span className="text-accent-teal mr-2">/</span> Bez viditelných profilů</li>
                    <li><span className="text-accent-teal mr-2">/</span> Lepení na OSB/SDK</li>
                  </ul>
                </div>
                <div>
                  <h4 className="text-sm font-bold text-arch-dark dark:text-white uppercase tracking-wider mb-3">Kovové profily</h4>
                  <ul className="text-sm text-arch-gray dark:text-gray-400 space-y-2">
                    <li><span className="text-accent-sage mr-2">/</span> 5, 8, 9mm profily</li>
                    <li><span className="text-accent-sage mr-2">/</span> Technický detail spáry</li>
                    <li><span className="text-accent-sage mr-2">/</span> Al/Ocel materiály</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Installation Steps Visual */}
          <div className="bg-white dark:bg-dark-surface border border-arch-border dark:border-dark-border p-12 flex flex-col justify-center">
            <h3 className="text-xs font-bold text-arch-gray dark:text-gray-500 uppercase tracking-widest mb-10 text-center">Standardní proces montáže</h3>
            
            <div className="space-y-8 relative">
              <div className="absolute left-[23px] top-0 bottom-0 w-[1px] bg-arch-border dark:bg-dark-border z-0"></div>
              
              {['Příprava rovného podkladu', 'Formátování a řezání', 'Aplikace montážního lepidla', 'Fixace a finální úpravy'].map((step, index) => (
                <div key={index} className="flex items-center relative z-10 group">
                  <div className={`w-12 h-12 bg-white dark:bg-dark-surface border border-arch-border dark:border-dark-border group-hover:border-brand-500 dark:group-hover:border-brand-500 flex items-center justify-center font-mono font-bold text-arch-dark dark:text-white flex-shrink-0 transition-colors`}>
                    {index + 1}
                  </div>
                  <div className="ml-6 text-sm font-bold text-arch-dark dark:text-white uppercase tracking-wider group-hover:text-brand-500 dark:group-hover:text-brand-500 transition-colors">
                    {step}
                  </div>
                </div>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default Installation;